import { CategoryState, CategoryResponseProps } from './types';
import { createSlice } from '@reduxjs/toolkit';
import { categoryList } from './category.services';

export const initialState: CategoryState = {
  data: {} as CategoryResponseProps,
  status: 'loading',
  error: {},
};

export const CategorySlice = createSlice({
  name: 'category',
  initialState,
  reducers: {},
  extraReducers: (builder) => {
    builder
      .addCase(categoryList.pending, (state) => {
        state.status = 'loading';
      })
      .addCase(categoryList.fulfilled, (state, action) => {
        if (action.payload) {
          state.data = action.payload.data;
          state.status = action.payload.status;
          state.error = action.payload.error;
        }
      })
      .addCase(categoryList.rejected, (state, action) => {
        state.status = 'error';
        state.error = action.error;
      });
  },
});

export const CategoryReducer = CategorySlice.reducer;
